import React from "react";
import TeamCard from "./TeamCard";
import teamData from "./teamData";

const Team = () => {
  return (
    <section className="team-section py-5">
      <div className="container-fluid px-4 px-lg-5">

        {/* <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="display-5 fw-bold team-heading">
              Our Leadership Team
            </h2>

            <p className="text-muted">
              Trusted partners protecting what you've built across continents.
            </p>
          </div>
        </div> */}

        <div className="row g-4">
          {teamData.map((member, index) => (
            <TeamCard key={index} member={member} />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Team;